<template>
  <div class="dragVerify">
    <div class="head">
      <span>请完成安全验证</span>
      <i @click="closeVerify" class="iconfont icon-guanbiicon"></i>
    </div>
    <div id="captcha"></div>
  </div>
</template>

<script>
import {
  createImageAuthCode,
  checkoutImageAuthCode,
} from "@/api/accountManage";
//全局vuex
import { mapGetters } from "vuex";
import DragVerify from "./index";
export default {
  name: "dragVerify",
  props: {
    business: {
      type: [Number, String],
    },
  },
  data() {
    return {
      DragVerify: null,
      ycoord: 0,
      imgUrl: null, // 验证的图片地址
      captchaKey: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(["business", "captchaType"]),
  },
  methods: {
    closeVerify() {
      this.$store.commit("SET_IMG_VERIFY", false);
      this.$store.commit("SET_CAPTCHA_TYPE", "");
      this.$store.commit("SET_CAPTCHA_KEY", "");
      this.$store.commit("RESET_SMS");
    },
    //获取拼图位置
    async init() {
      document.getElementById("captcha").innerHTML = "";
      const paramsData = {
        business: this.business,
        lowerX: 73,
        upperX: 247,
        lowerY: 28,
        upperY: 121,
      };
      const res = await createImageAuthCode(paramsData);
      const { coordsX, coordsY, imageUrl, captchaKey } = res.data;
      this.ycoord = coordsY;
      //初始化拼图验证
      this.DragVerify = new DragVerify({
        el: document.getElementById("captcha"),
        onSuccess: this.onSuccess,
        onFail: this.onFail,
        onRefresh: this.onRefresh,
        x: coordsX,
        y: coordsY,
        img: imageUrl,
      });
      this.captchaKey = captchaKey;
      this.imgUrl = imageUrl;
      this.DragVerify.init();
    },
    // 前端验证成功后
    async onSuccess(x) {
      const paramsData = {
        type: this.captchaType,
        business: this.business,
        coordsX: x,
        imageUrl: this.imgUrl,
        coordsY: this.ycoord,
        captchaKey: this.captchaKey,
      };
      let { data } = await checkoutImageAuthCode(paramsData);
      let timer = setInterval(() => {
        this.$store.commit("SET_TIME_REMAINING");
      }, 1000);
      this.$store.commit("SET_TIMER", timer);
      this.$store.commit("SET_SEND_STATUS", false);
      this.$emit("verifySuccess", data);
    },
    //验证失败
    onFail(left) {
      console.log(left);
    },
    //刷新
    onRefresh() {
      this.init();
    },
  },
};
</script>

<style lang="scss">
.dragVerify {
  background: #fff;
  display: inline-block;
  padding: 20px;
  border-radius: 4px;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    span {
      font-size: 15px;
      color: #333333;
      font-weight: 600;
    }
    i {
      color: #999999;
      font-size: 14px;
      cursor: pointer;
    }
  }
  #captcha {
    min-height: 257px;
  }
  .canvas {
    border-radius: 4px;
  }
  .block {
    position: absolute;
    left: 0;
    top: 0;
  }
  .sliderContainer {
    position: relative;
    text-align: center;
    width: 320px;
    height: 41px;
    line-height: 41px;
    margin-top: 14px;
    background: #e9ebf1;
    font-size: 16px;
    font-weight: 500;
    color: #9da1ac;
    padding-left: 46px;
  }

  .sliderContainer_active .slider {
    height: 41px;
  }

  .sliderContainer_active .sliderMask {
    height: 41px;
  }

  .sliderContainer_success .slider {
    height: 41px;
    background-color: #52ccba !important;
  }

  .sliderContainer_success .sliderMask {
    height: 41px;
    background-color: #d2f4ef;
  }

  .sliderContainer_success .sliderIcon {
    background-position: 0 0 !important;
  }

  .sliderContainer_fail .slider {
    height: 41px;
    background-color: #f57a7a !important;
  }

  .sliderContainer_fail .sliderMask {
    height: 41px;
    background-color: #fce1e1;
  }

  .sliderContainer_fail .sliderIcon {
    top: 14px;
    background-position: 0 -82px !important;
  }

  .sliderContainer_active .sliderText,
  .sliderContainer_success .sliderText,
  .sliderContainer_fail .sliderText {
    display: none;
  }

  .sliderMask {
    position: absolute;
    left: 0;
    top: 0;
    height: 41px;
    background: #d1e9fe;
  }

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 41px;
    height: 41px;
    cursor: pointer;
    transition: background 0.2s linear;
    background: #fff;
    border-radius: 4px;
    border: 1px solid #e8e8eb;
    span {
      top: -2px;
      display: inline-block;
      background-image: url("../../assets/img/arrows.png");
      background-size: 100% 100%;
      width: 16px;
      height: 12px;
    }
  }

  .slider:hover {
    background: #1991fa;
  }

  .icon-a-wangyou2x {
    font-size: 18px;
    color: #fff;
  }

  .icon-a-shuaxin2x {
    position: absolute;
    font-size: 24px;
    right: 25px;
    top: -46px;
    color: #909399;
    cursor: pointer;
    &:hover {
      color: #2858f8;
    }
  }
}
</style>
